import React, { useState } from "react";
import { useQuery } from "react-query";
import {
  Grid,
  Typography,
  Button,
  TextField,
  InputLabel,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { getMaestras } from "../../actions/maestras-actions";
import { recoveryPost } from "../../actions/recoveryPassword-action";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useForm, } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useStateValue } from "../../context/store";
import { REQUIRED_MESSAGE } from "../../constants";
import EmailIcon from "@material-ui/icons/Email";
import LoginContainer from "./LoginContainer";
import TitleCase from "react-title-case";
import { styles } from "./styles";
import _ from "lodash";
import * as yup from "yup";

const ValidatePassword = (props) => {
  const classes = styles();
  const [loading, setLoading] = useState(false);
  const [errorType, setErrorType] = useState(false);
  const [validatePasport, setValidatePasport] = useState({
    documentNumber: "",
    documentType: 1,
  });
  const [{}, dispatch] = useStateValue();
  const [disabledOnsubmit, setDisabledOnsubmit] = useState(false)
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setValue("documentType");
    return response.data.maestras;
  };

  const { data: dataListaMaestras, status: statusListaMaestras } = useQuery(
    "listaMaestras",
    getListaMaestras
  );

  const typeDocument = typeof validatePasport.documentType === "number";

  const schema = yup.object().shape({
    documentType: typeDocument ? yup.string().required(REQUIRED_MESSAGE) : null,
    documentNumber: yup
    .string()
    .required( REQUIRED_MESSAGE )
      .min(3, "Ingrese mínimo 3 dígitos")
      .max(16, "Ingrese máximo 16 dígitos"),
    email: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(100, "Ingrese máximo 100 caracteres")
      .email("Ingrese un correo electrónico válido"),
  });

  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const handleClickClose = () => {
    setLoading(false);
    setDisabledOnsubmit(false)
    setMessage({ ...message, open: false });
  };
  const regex = /^[a-zA-Z0-9 ]+$/;

  const handlechange = (e) => {
    const { name, value } = e.target;
    setValidatePasport({ ...validatePasport, [name]: value });
    if (validatePasport.documentType === "PP") {
      if (name === "documentNumber") {
        if (regex.test(value)) {
          setErrorType(false);
        } else setErrorType(true);
      }
    }
  };

  const onSubmit = (data) => {
    setDisabledOnsubmit(true)
    if (errorType) {
      return null;
    } else {
      setLoading(true);
      const recoveryPasswordUser = async () => {
        const newData = { ...data, documentType: validatePasport.documentType };
        const response = await recoveryPost(newData, dispatch)
         
            if (response?.status >= 200 && response?.status <= 399) {
              props.history.push("/auth/success");
            } else if(response?.status > 399 && response?.status !== 401 && response?.status !==403) {
              setMessage({
                description: response?.data?.detail,
                textButtonSubmit: "ACEPTAR",
                handleClick: () => handleClickClose(),
                oneButtons: true,
                type: "WARNING",
                open: true,
              });
            } else {
              setMessage({
                description:  "Ocurrió un error procesando su solicitud, inténtelo nuevamente",
                textButtonSubmit: "ACEPTAR",
                handleClick: () => handleClickClose(),
                oneButtons: true,
                type: "WARNING",
                open: true,
              });
            }
          }
      recoveryPasswordUser();
    }
  };

  const formValidatePassword = () => (
    <div>
      <Typography component="h1" className={classes.stylesTypography}>
        ¿Contraseña olvidada?
      </Typography>
      <form style={{ marginTop: "3%" }} onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12} md={6} lg={12}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("documentType") &&
              typeDocument &&
              errors["documentType"].message
            }
          >
            <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
              Tipo de documento
            </InputLabel>
            <Select
              fullWidth
              onChange={handlechange}
              inputRef={register}
              label="TIPO DE DOCUMENTO"
              defaultValue="Selecione"
              name="documentType"
              size="small"
              value={validatePasport.documentType}
              notched={true}
              margin="normal"
              inputProps={{
                name: "documentType",
                id: "outlined-select-documentType",
              }}
            >
              <MenuItem value={1} disabled>
                <em>Seleccione</em>
              </MenuItem>
              {statusListaMaestras === "success" &&
                _.sortBy(
                  dataListaMaestras.tipoDocumnetoIdentificacion,
                  (o) => o.value
                ).map((gender) => (
                  <MenuItem
                    className={classes.menuItem}
                    key={gender.index}
                    value={gender.key}
                  >
                    <TitleCase string={gender.value} />
                  </MenuItem>
                ))}
            </Select>

            <FormHelperText>
              {errors.hasOwnProperty("documentType") &&
                typeDocument &&
                errors["documentType"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={12}>
          <FormControl fullWidth>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputRef={register}
              type={
                validatePasport.documentType &&
                validatePasport.documentType === "PP"
                  ? "text"
                  : "number"
              }
              name="documentNumber"
              defaultValue=""
              placeholder="Número de documento"
              onChange={handlechange}
              variant="outlined"
              fullWidth
              margin="normal"
              label="Número de Documento"
              error={
                (errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message) ||
                (errorType && "Ingrese un número de documento válido")
              }
              helperText={
                (errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message) ||
                (errorType && "Ingrese un número de documento válido")
              }
            />
          </FormControl>
        </Grid>
        <Grid
          container
          spacing={2}
          justify="center"
          direction="row"
          style={{ marginTop: "5%" }}
        >
          <Typography component="h1" className={classes.fontSize14}>
            Le será enviado un enlace para restablecer su contraseña
          </Typography>
          <Grid item xs={12} md={6} lg={12}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                type="text"
                name="email"
                defaultValue=""
                placeholder="ejemplo@correo.com"
                variant="outlined"
                fullWidth
                margin="normal"
                label="Correo electrónico"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
                error={
                  errors.hasOwnProperty("email") && errors["email"].message
                }
                helperText={
                  errors.hasOwnProperty("email") && errors["email"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
            <Button
              type="submit"
              fullWidth
              disabled={disabledOnsubmit}
              variant="contained"
              className={classes.submit}
              disableElevation
            >
              {loading ? (
                <CircularProgress style={{ width: 25, height: 25 }} />
              ) : (
                "Enviar"
              )}
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Button
              fullWidth
              disabled={disabledOnsubmit}
              variant="contained"
              className={classes.buttonBack}
              onClick={() => props.history.push("/auth/login")}
              disableElevation
            >
              Regresar
            </Button>
          </Grid>
        </Grid>
      </form>
      <ModalConfirm
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  );

  return <LoginContainer>{formValidatePassword()}</LoginContainer>;
};

export default ValidatePassword;
